//
// Generated class RelationBookingZone
//

/// <reference path="RelationBookingZone_ManagedObject.ts" />

class RelationBookingZone extends RelationBookingZone_ManagedObject
{ 
}
